import {initSortBySelects} from "../global/sortBySelect";
import {initFilterItems} from "../global/filterItem";
import {initItemlistToggle} from "../../../default/global/js/itemlistToggle";
import {toggleItemlistStickyOrderBar} from "../../../default/global/js/itemlistStickyOrderBar";
import {initSalespersonNavigation} from "../../../reusch_b2b/src/js/salesperson";
import {decodedLinks} from "./decodedLinks";
import hoverintent from "../../../default/global/js/hoverintent";
import {isTouchDevice} from "../../../default/global/js/touchDevice";

function showHideFilters(wrapper = document) {
    let showFilterBtn = wrapper.querySelector("#showHideFilters");
    if(showFilterBtn) {
        let filterBox = wrapper.querySelector(".filterWrapper");
        if(filterBox && !filterBox.classList.contains("is-active")) {
            filterBox.setAttribute("inert", "");
        }

        showFilterBtn.addEventListener("click", function () {
            let filterBox = wrapper.querySelector(".filterWrapper");
            if(filterBox) {
                if(filterBox.classList.contains("is-active")) {
                    closeFilters(showFilterBtn,filterBox);
                } else {
                    openFilters(showFilterBtn, filterBox);
                    setTimeout(function () {
                        const activeFiltersHeadline = filterBox.querySelector(".activeFilters__headline");
                        const hasActiveFilters = filterBox.querySelector(".activeFilterElement") !== null;
                        if (hasActiveFilters && activeFiltersHeadline) {
                            activeFiltersHeadline.focus();
                        } else {
                            const firstFilter = filterBox.querySelector(".filterContent .filterItem__selected");
                            if (firstFilter) {
                                if (!firstFilter.hasAttribute("tabindex")) {
                                    firstFilter.setAttribute("tabindex", "-1");
                                }
                                firstFilter.focus();
                            }
                        }
                    }, 210);
                }
            }
        });
        for(let close of wrapper.querySelectorAll(".js-filterClose")) {
            close.addEventListener("click", function () {
                let filterBox = wrapper.querySelector(".filterWrapper");
                if(filterBox) {
                    closeFilters(showFilterBtn,filterBox);
                }
            });
        }
    }
}

function updateCategoryView(response,querySelect = ".categoryStartWrapper"){
    const oldView = document.querySelector(querySelect);
    const newView = response.querySelector(querySelect);
    if(oldView && newView) {
        oldView.innerHTML = newView.innerHTML;
        oldView.className = newView.className;
    }
}

export function updateFilterViews(response,updateCategoryViews = false, paginationClick = false, skipOpenFilters = false){
    const oldListView = document.querySelector(".itemListView");
    const newListView = response.querySelector(".itemListView");
    if(oldListView && newListView) {
        oldListView.innerHTML = newListView.innerHTML;
        let showFilterBtn = oldListView.querySelector("#showHideFilters");
        let filterBox = oldListView.querySelector(".filterWrapper");
        oldListView.classList.remove("is-loading");

        if(showFilterBtn && filterBox && !paginationClick && !skipOpenFilters){
            openFilters(showFilterBtn, filterBox);
        }
        reuschFilter(oldListView);
        initItemlistToggle();
        initSalespersonNavigation(oldListView);

        if (!isTouchDevice()) {
            for (let el of oldListView.querySelectorAll('.itembox,.iconbarItem')) {
                hoverintent(el);
            }
        }

        if(updateCategoryViews){
            updateCategoryView(response,".categoryStartWrapper");
            updateCategoryView(response,".categoryDescription.categoryDescription--2");
        }

        if(oldListView.closest(".categoryMain")){
            window.scrollTo({
                top: window.scrollY + oldListView.closest(".categoryMain").getBoundingClientRect().top - 100,
                left: 0
            });
        }
    }else{
        window.location.reload();
    }
}

export function openFilters(filterBtn, filterBox){
    if(filterBtn && filterBox){
        let span = filterBtn.querySelector("span");
        if(span){
            filterBox.classList.add("is-active");
            filterBox.removeAttribute("inert");
            span.innerHTML = filterBtn.dataset.hide;
            filterBtn.setAttribute("aria-expanded", "true");
        }
    }
}

export function closeFilters(filterBtn, filterBox){
    if(filterBtn && filterBox){
        let span = filterBtn.querySelector("span");
        filterBox.classList.remove("is-active");
        filterBox.setAttribute("inert", "");
        span.innerHTML = filterBtn.dataset.show;
        filterBtn.setAttribute("aria-expanded", "false");
    }
}

function initItemlistPagination(wrapper = document) {
    for(let paginationItem of wrapper.querySelectorAll(".itemlistPaginationFooter a.pagination__item")){
        paginationItem.addEventListener("click", function (e) {
            e.preventDefault();
            let itemListView = document.querySelector(".itemListView");
            if(itemListView){
                itemListView.classList.add("is-loading");
            }
            const formData = new FormData();
            formData.append("isAjaxFilter",true);
            fetch(paginationItem.getAttribute("href"), {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Fehlerhafte Server-Antwort');
                    }
                    return response.text();
                })
                .then(data => {
                    const responseHtml = new DOMParser().parseFromString(data, 'text/html');
                    updateFilterViews(responseHtml, false, true);
                    history.pushState(null, "", paginationItem.getAttribute("href"));

                    // 👇 Sticky Order Bar nach AJAX-Seitenwechsel zurücksetzen
                    resetItemlistStickyOrderBar();
                    decodedLinks();

                })
                .catch(error => {
                    console.error('Ajax-Fehler:', error);
                });
        });
    }
}

function initRemoveActiveFilters(wrapper = document) {
    for(let removeActiveFilter of wrapper.querySelectorAll(".js-removeActiveFilter")){
        removeActiveFilter.addEventListener("click", function (e) {
            e.preventDefault();
            let itemListView = document.querySelector(".itemListView");
            if(itemListView){
                itemListView.classList.add("is-loading");
            }
            const oldUrl = window.location.href.split('?')[0];
            let newUrl = "";
            let updateUrl = false;
            fetch(removeActiveFilter.getAttribute("href"), {
                method: 'GET',
                headers: {'X-DC-Filter-Ajax': '1'}
            })
                .then(response => {
                    const canonical = response.headers.get('X-DC-Canonical-Url');
                    newUrl = (canonical
                        ? new URL(canonical, window.location.href).href
                        : response.url).split('?')[0];
                    updateUrl = (oldUrl !== newUrl);
                    if (!response.ok) {
                        throw new Error('Fehlerhafte Server-Antwort');
                    }
                    return response.text();
                })
                .then(data => {
                    const responseHtml = new DOMParser().parseFromString(data, 'text/html');
                    updateFilterViews(responseHtml,updateUrl);
                    window.history.pushState({}, '', newUrl);
                    decodedLinks();
                })
                .catch(error => {
                    console.error('Ajax-Fehler:', error);
                });
        });
    }
}

function initRemoveAllActiveFilters(wrapper = document) {
    for(let removeAllActiveFilter of wrapper.querySelectorAll(".js-removeAllFilters")){
        removeAllActiveFilter.addEventListener("click", function () {
            let itemListView = document.querySelector(".itemListView");
            if(itemListView){
                itemListView.classList.add("is-loading");
            }
            const oldUrl = window.location.href.split('?')[0];
            let newUrl = "";
            let updateUrl = false;
            fetch(removeAllActiveFilter.dataset.href, {
                method: 'GET',
                headers: {'X-DC-Filter-Ajax': '1'}
            })
                .then(response => {
                    const canonical = response.headers.get('X-DC-Canonical-Url');
                    newUrl = (canonical
                        ? new URL(canonical, window.location.href).href
                        : response.url).split('?')[0];
                    updateUrl = (oldUrl !== newUrl);
                    if (!response.ok) {
                        throw new Error('Fehlerhafte Server-Antwort');
                    }
                    return response.text();
                })
                .then(data => {
                    const responseHtml = new DOMParser().parseFromString(data, 'text/html');
                    updateFilterViews(responseHtml,updateUrl);
                    window.history.pushState({}, '', newUrl);
                    resetItemlistStickyOrderBar();
                    decodedLinks();

                })
                .catch(error => {
                    console.error('Ajax-Fehler:', error);
                });
        });
    }
}

function resetItemlistStickyOrderBar() {
    const counter = document.getElementById('js-itemlistStickyOrderBarCount');
    if (counter) {
        counter.innerText = '0';
    }
    toggleItemlistStickyOrderBar(false);
}

const FILTER_CLOSED_KEY = 'b2b_filters_closed';

export function initAutoOpenFilters() {
    const filterBtn = document.querySelector('#showHideFilters');
    const filterBox = document.querySelector('.filterWrapper');

    if (!filterBtn || !filterBox) return;

    if (!sessionStorage.getItem(FILTER_CLOSED_KEY)) {
        openFilters(filterBtn, filterBox);
    }

    filterBox.querySelectorAll('.js-filterClose').forEach(btn => {
        btn.addEventListener('click', () => {
            sessionStorage.setItem(FILTER_CLOSED_KEY, '1');
        });
    });

    // filter.js ändert is-active vor diesem Listener → invertierte Prüfung
    filterBtn.addEventListener('click', () => {
        if (filterBox.classList.contains('is-active')) {
            sessionStorage.removeItem(FILTER_CLOSED_KEY);
        } else {
            sessionStorage.setItem(FILTER_CLOSED_KEY, '1');
        }
    });
}


function initActiveFiltersKeyNav(wrapper = document) {
    const headline = wrapper.querySelector('.activeFilters__headline');
    if (!headline) return;
    headline.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' && e.shiftKey) {
            const filterBtn = wrapper.querySelector('#showHideFilters');
            if (filterBtn) {
                e.preventDefault();
                filterBtn.focus();
            }
        }
    });
}

function moveOrderOptionAfterFilterWrapper(wrapper = document) {
    const showFilterBtn = wrapper.querySelector('#showHideFilters');
    if (!showFilterBtn) return;
    const listSort = wrapper.querySelector('.listSort');
    const listWrapper = wrapper.querySelector('.listWrapper');
    const orderOption = wrapper.querySelector('.orderOption');
    if (!listSort || !listWrapper || !orderOption) return;

    // DOM-Reihenfolge für Screenreader/Tastaturnavigation:
    // 1. button#showHideFilters  2. filterContent  3. orderOption
    listWrapper.insertAdjacentElement('afterend', orderOption);
    listSort.classList.add('listSort--a11y-reordered');
}

export function reuschFilter(wrapper = document) {
    moveOrderOptionAfterFilterWrapper(wrapper);
    showHideFilters(wrapper);
    initSortBySelects(wrapper);
    initFilterItems(wrapper);
    initItemlistPagination(wrapper);
    initRemoveActiveFilters(wrapper);
    initRemoveAllActiveFilters(wrapper);
    initActiveFiltersKeyNav(wrapper);
}